import { css, keyframes } from "styled-components";

export const shimmer = (
  from = "200px",
  iteration = "infinite",
  duration = "1.5s",
  timing = "linear"
) => {
  const shimmerAnimation = keyframes`
  0% {
    background-position: -${from} 0;
  }
  100% {
    background-position: calc(${from} + 100%) 0;
  }
`;

  return css`
    animation: ${shimmerAnimation} ${duration} ${iteration} ${timing};
  `;
};
